
export class Saseung {
  hanja?: string;
  hangul: string;
  saseung: string;
  meaning: string;
  meaning2: string | null;
  huns: Array<string>;

  constructor(obj?: any) {
    this.hanja            = obj?.hanja;
    this.hangul           = (obj && obj.hangul)           ?? null;
    this.saseung          = (obj && obj.saseung)          ?? null;
    this.meaning          = (obj && obj.meaning)          ?? null;
    this.huns             = (obj && obj.huns)             ? obj.huns.split(',') : null;

    this.meaning2         = this.meaning ? this.getMeaning2() : null;

    // console.warn('meaning =', this.meaning);
    // console.warn('meaning2 =', this.meaning2);
  }

  private getMeaning2(): string | null {
    if (this.huns === null) {
      return this.meaning;
    }

    const hun_set = new Set(this.huns);

    const meaning_list = this.meaning.split(',');
    const meaning2_list = meaning_list.map((meaning: string, index) => {
       const _trim = meaning.trim();
        if (hun_set.has(_trim)) {
          return meaning.replace(_trim, `<a href="${_trim}" class="hunlink">${_trim}</a>`);
        }
        return _trim;
    });
    return meaning2_list.join(',');
  }
}


export class SaseungHanja {
  hangul: string;
  hanja: string;
  saseungs: Array<Saseung> | null = null;

  get key() {
    return `${this.hangul}_${this.hanja}`;
  }
  constructor(obj?: any) {
    this.hangul           = (obj && obj.hangul)           ?? null;
    this.hanja            = (obj && obj.hanja)            ?? null;

    if ('saseungs' in obj) {
      this.saseungs = new Array<Saseung>();

      obj.saseungs.forEach((value: Saseung) => {
        const value2 = {
          ...value,
          hangul: this.hangul,
          hanja: this.hanja,
        }
        this.saseungs?.push(new Saseung(value2));
      });
    }
  }
}


/**
 * 훈 정보
 * 훈이 포함된 사성 정보를 가지고 있다.
 */
export class SaseungHun {
  hun: string;
  saseungs: Array<Saseung>;

  constructor(obj?: any) {
    this.hun              = (obj && obj.hun)              ?? null;

    if ('saseungs' in obj && obj.saseungs.length > 0) {
      this.saseungs = obj.saseungs.map((value: object) => new Saseung(value));
    }
    else {
      this.saseungs = [];
    }
  }
}
